import React from 'react';

const Header = () => {
  return <header>
    <h1><a href="https://maybank2u.com.my/">Maybank</a></h1></header>;
};

export default Header;
